import { DetailItem as StyledDetailItem } from "./DetailStyles";

interface DetailItemProps {
    label: string;
    value: string | number;
}

const DetailItem = ({ label, value }: DetailItemProps) => {
    return (
        <StyledDetailItem>
            <span>{label}</span>
            <span>{value}</span>
        </StyledDetailItem>
    );
};

export default DetailItem;